export enum LinkType {
  PROJECT,
  COMPANY,
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/link-type.enum.ts